"use client";
/* 🔑 공용 원자 — 두 스킨(`_skins/*`)이 같이 씁니다. 스킨 고유의 모양은 여기 두지 않습니다 (`docs/base/11` §5-2). */

import { SUPPORT_EMAIL } from "../_lib/site";
import { useSite } from "../_lib/useSite";

/*
 * 오픈 준비 중 — 🔑 **스킨과 무관한 공용 화면**입니다 (`app/page.tsx` 가 스킨 화면 대신 그립니다).
 *
 * 🔑 서비스명은 몰 설정(`useSite().brand`)에서 옵니다 — 오픈 전에 관리자가 이름을 먼저
 *    정해 두면 준비 중 화면에도 그 이름이 나갑니다. 문의 주소는 배포 설정(`_lib/site.ts`).
 */
export function ComingSoon() {
  const { brand } = useSite();

  return (
    <main className="flex min-h-dvh items-center justify-center px-6 py-16">
      <div className="w-full max-w-lg">
        <p className="text-caption font-bold tracking-[0.2em] text-ink-faint uppercase">{brand.siteName}</p>
        <h1 className="mt-4 text-title leading-snug font-bold text-ink sm:text-hero">오픈 준비 중</h1>
        <div className="mt-6 space-y-4 text-body leading-relaxed text-ink-soft">
          <p>오픈 일정은 추후 안내 예정입니다.</p>
        </div>
        <hr className="my-8 border-line" />
        {SUPPORT_EMAIL && <dl className="space-y-2 text-body text-ink-faint"><div className="flex gap-3"><dt className="w-16 shrink-0">문의</dt><dd><a className="underline underline-offset-4 hover:text-ink" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a></dd></div></dl>}
      </div>
    </main>
  );
}
